import { AdminAttachments, uploadFileToStorage } from "@/service/api/admin-attachments";

interface UploadFilesOptions {
  signal?: AbortSignal;
  onProgress?: (uploadedCount: number) => void;
}

export const uploadFiles = async (files: File[], { signal, onProgress }: UploadFilesOptions = {}): Promise<string[]> => {
  let uploadedCount = 0;

  return Promise.all(
    files.map(async (file) => {
      const { uploadUrl, attachmentId } = await AdminAttachments.generateUploadUrl(
        { fileName: file.name, mimeType: file.type },
        { signal },
      );

      await uploadFileToStorage(uploadUrl, file, { signal });
      await AdminAttachments.confirmUpload({ id: attachmentId }, { signal });

      onProgress?.(++uploadedCount);

      return attachmentId;
    }),
  );
};
